export class RequiredValidationRule {
    // #region Vars
    name = 'required';
    // #endregion
    // #region Run
    validate(field, rule, value, object) {
        // #region Message
        //Fixed
        let tMessage = host.localizer?.tc('system.Validation.Required', [field.displayName]);
        //Message
        if (rule.message) {
            tMessage = utils.format(rule.message, field.displayName);
        }
        // #endregion
        // #region Check
        if (value === null) {
            return { isValid: false, message: tMessage };
        }
        let type = typeof value;
        if (type === 'undefined' || type === null)
            return { isValid: false, message: tMessage };
        if (type == "boolean") {
            if (value) {
                return { isValid: true };
            }
            else {
                return { isValid: false, message: tMessage };
            }
        }
        if (/(string|array|number)/.test(type) === false) {
            return { isValid: false, message: tMessage };
        }
        if (value.toString().length === 0) {
            return { isValid: false, message: tMessage };
        }
        // #endregion
        return { isValid: true };
    }
}
